import { Component } from 'vue-property-decorator';


import { Type } from "src/utils";

/**
 * 表示一个文件使用类型。
 * @enum
 * @version 1.0.0
 */
enum FolderUseType
{
    /**
     * 图片。
     * @member
     */
    images = 1,

    /**
     * 音频。
     * @member
     */
    audios = 2,

    /**
     * 视频。
     * @member
     */
    vedios = 3,

    /**
     * 文档。
     * @member
     */
    documents = 4,
}

/*
* 定义枚举元数据。
*/
Type.setMetadata(FolderUseType,
{
    images:
    {
        alias: "图片",
        description: {
            type: "image/*"
        }
    },
    audios:
    {
        alias: "音频",
        description: {
            type: "audio/*"
        }
    },
    vedios:
    {
        alias: "视频",
        description: {
            type: "video/*"
        }
    },
    documents:
    {
        alias: "文档",
        description: {
            type: ".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        }
    }
});

export default FolderUseType;
